import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { loadTodosCountAsync, loadTodoSummaryAsync, setTodos } from "store/actions/todoActions";
import { useDispatch, useSelector } from "react-redux";
import { AppState, store } from "store";
import { setTodoListNavigation } from "store/actions/todoNavigationActions";
//#endregion
//#region types
import { EventConstants, TodoConstants } from "utils/constants";
//#endregion
//#region components
import Notifications from "./notifications";
import { usePreloadedTodoData } from "components/todos";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { UrlHelper, EventHelper } from "utils/helpers";
import { TodoService } from "services";

const NotificationsContainer: React.FC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const count = useSelector((store: AppState) => store.todos.todoCount);
  const selectedCompanyId = useSelector((store: AppState) => store.auth.selectedCompany.id);

  const toggleNotifications = () => {
    dispatch(
      setTodoListNavigation({
        indexToOpen: 0,
        pageToOpen: 0,
        numPerPage: TodoConstants.TodosPerPage,
        todoCanIncludeInNavigation: () => true,
      })
    );
    navigate(`${UrlHelper.formatPath(`/Todo/${0}`)}`, {
      state: { background: location },
    });
  };

  const loadTodos = (companyId: number) => dispatch(loadTodosCountAsync(companyId));
  const loadTodoSummary = (companyId: number) => dispatch(loadTodoSummaryAsync(companyId));
  const { preLoadNext } = usePreloadedTodoData();

  React.useEffect(() => {
    if (selectedCompanyId) {
      loadTodos(selectedCompanyId);
      loadTodoSummary(selectedCompanyId);

      const updateTodosFunc = updateTodos.bind(null, selectedCompanyId);
      const interval = setInterval(() => {
        updateTodosFunc();
      }, TodoConstants.TodoLoadIntervalMs);

      return () => clearInterval(interval);
    }
  }, [selectedCompanyId]);

  /**
   * @deprecated This function is deprecated. Use useSelector for Redux state access.
   *
   * @see useSelector - React Redux hook for accessing state
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * const isValid = checkIfTodoUpdateValid(companyId);
   *
   * @example
   * // New way (recommended):
   * const selectedCompanyId = useSelector((state: AppState) => state.auth.selectedCompanyId);
   * const showTodos = useSelector((state: AppState) => state.todos.showTodos);
   *
   * const checkIfTodoUpdateValid = (companyId: number) => {
   *   return companyId === selectedCompanyId && !showTodos;
   * };
   */
  const checkIfTodoUpdateValid = (selectedCompanyId: number) => {
    const globalState = store.getState();
    return selectedCompanyId === globalState.auth.selectedCompanyId && !globalState.todos.showTodos;
  };

  const updateTodos = (selectedCompanyId: number) => {
    if (checkIfTodoUpdateValid(selectedCompanyId)) {
      TodoService.getTodos(0).then((res) => {
        if (checkIfTodoUpdateValid(selectedCompanyId)) {
          dispatch(setTodos(res.items ?? [], res.totalItems));
          if (res.items?.length) {
            preLoadNext(res.items[0]);
          }
        }
      });
      loadTodoSummary(selectedCompanyId);
    }
  };

  React.useEffect(() => {
    EventHelper.subscribeEvent(EventConstants.ToggleNotifications, toggleNotifications);

    return () => {
      EventHelper.unsubscribeEvent(EventConstants.ToggleNotifications, toggleNotifications);
    };
  }, []);

  return count !== 0 ? <Notifications count={count} toggleNotifications={toggleNotifications} /> : <></>;
};

export default React.memo(NotificationsContainer);
